/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var CalendarVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CalendarVisualModelExport, _super);
    function CalendarVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i = 0;
        _this.h = 0;
        _this.e = null;
        _this.g = null;
        _this.c = null;
        _this.f = null;
        _this.d = null;
        _this.b = null;
        _this.a = null;
        _this.r = null;
        _this.s = null;
        _this.t = null;
        _this.m = 0;
        _this.p = null;
        _this.q = null;
        _this.n = null;
        _this.j = null;
        _this.k = null;
        _this.l = null;
        return _this;
    }
    CalendarVisualModelExport.prototype.o = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("Density : " + this.i + ", ");
        a.l("BaseTheme : " + this.h + ", ");
        a.l("SelectedDateBackgroundColor : " + this.e.serialize() + ", ");
        a.l("SelectedFocusDateBackgroundColor : " + this.g.serialize() + ", ");
        a.l("FocusDateBackgroundColor : " + this.c.serialize() + ", ");
        a.l("SelectedDateTextColor : " + this.f.serialize() + ", ");
        a.l("FocusDateTextColor : " + this.d.serialize() + ", ");
        a.l("CurrentDateTextColor : " + this.b.serialize() + ", ");
        a.l("CurrentDateBorderColor : " + this.a.serialize() + ", ");
        if (!stringIsNullOrEmpty(this.r)) {
            a.l("textStyleFontStyle : \"" + this.r + "\", ");
        }
        if (!stringIsNullOrEmpty(this.s)) {
            a.l("textStyleFontVariant : \"" + this.s + "\", ");
        }
        if (!stringIsNullOrEmpty(this.t)) {
            a.l("textStyleFontWeight : \"" + this.t + "\", ");
        }
        if (!stringIsNullOrEmpty(this.p)) {
            a.l("textStyleFontFamily : \"" + this.p + "\", ");
        }
        if (!stringIsNullOrEmpty(this.q)) {
            a.l("textStyleFontStretch : \"" + this.q + "\", ");
        }
        if (!isNaN_(this.m)) {
            a.l("textStyleFontSize : " + this.m + ", ");
        }
        a.l("activePicker : \"" + this.n + "\", ");
        a.l("buttonsModels: [");
        for (var b = 0; b < this.j.count; b++) {
            if (b != 0) {
                a.l(",");
            }
            var c = this.j._inner[b].aa.charAt(0).toString().toLowerCase() + this.j._inner[b].aa.substr(1);
            a.l(this.j._inner[b].ab());
        }
        a.l("],");
        a.l("dayNamesModels: [");
        for (var d = 0; d < this.k.count; d++) {
            if (d != 0) {
                a.l(",");
            }
            a.l(this.k._inner[d].h());
        }
        a.l("],");
        a.l("weekNumbersModels: [");
        for (var e = 0; e < this.l.count; e++) {
            if (e != 0) {
                a.l(",");
            }
            a.l(this.l._inner[e].h());
        }
        a.l("]");
        a.l("}");
        return a.toString();
    };
    CalendarVisualModelExport.$t = markType(CalendarVisualModelExport, 'CalendarVisualModelExport');
    return CalendarVisualModelExport;
}(Base));
export { CalendarVisualModelExport };
//# sourceMappingURL=CalendarVisualModelExport.js.map
